import React from "react";
import { C } from "../constants";

/**
 * "Must fill" box. Always visible on the page that owns the fields so nobody
 * has to guess what is mandatory. Green once done, red while missing.
 */
export default function RequiredChecklist({ issues = [], title = "Required to continue", onGo }) {
  if (!issues.length) return null;
  const missing = issues.filter((i) => !i.ok);
  const allOk = missing.length === 0;
  return (
    <div
      role="status"
      style={{
        marginBottom: 14,
        padding: "10px 12px",
        borderRadius: 10,
        border: `1px solid ${allOk ? "#A7F3D0" : "#FECACA"}`,
        background: allOk ? "#ECFDF5" : "#FEF2F2",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 800, fontSize: 13, color: C.text, marginBottom: 6 }}>
        <i
          className={`ti ${allOk ? "ti-circle-check" : "ti-alert-circle"}`}
          style={{ fontSize: 17, color: allOk ? "#059669" : C.error }}
        />
        {allOk ? "All required fields are filled" : title}
        {!allOk && (
          <span style={{ fontWeight: 600, color: C.muted, fontSize: 12 }}>
            · fields marked <span style={{ color: C.error }}>*</span> must be filled
          </span>
        )}
      </div>
      <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 4 }}>
        {issues.map((i) => (
          <li key={i.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12.5, color: C.text }}>
            <i
              className={`ti ${i.ok ? "ti-check" : "ti-point-filled"}`}
              style={{ fontSize: 14, color: i.ok ? "#059669" : C.error }}
            />
            <span style={{ fontWeight: i.ok ? 500 : 700 }}>
              {i.label} <span style={{ color: C.error }}>*</span>
            </span>
            {!i.ok && onGo && (
              <button
                type="button"
                onClick={() => onGo(i.page)}
                style={{ border: "none", background: "transparent", color: C.primary, fontWeight: 700, fontSize: 12, cursor: "pointer", padding: 0 }}
              >
                Fix
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
